import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {addSupplier} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import InputContact from "../common/InputContact";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddSupplierForm extends Component {

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = e => {
    const {salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.addSupplier({...values, salonId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Supplier">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {initialValue: ''})(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Street Address"
          >
            {getFieldDecorator('addressStreet')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="City"
          >
            {getFieldDecorator('addressCity')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="State/Province"
          >
            {getFieldDecorator('addressState')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Country"
          >
            {getFieldDecorator('addressCountry')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Postal Code"
          >
            {getFieldDecorator('addressPostalCode')(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Contact"
          >
            {getFieldDecorator('contact', {initialValue: null})(
              <InputContact key='add-supplier'/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Supplier
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddSupplierForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addSupplier: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  salonId: PropTypes.string,
};

const AddSupplierPage = Form.create()(AddSupplierForm);

const mapStateToProps = state => ({
  loading: state.supplier.addingSupplier,
  salonId: state.salon.selectedSalonId,
});

const mapDispatchToProps = dispatch => ({
  addSupplier: bindActionCreators(addSupplier, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSupplierPage);



// WEBPACK FOOTER //
// ./src/Supplier/AddSupplierPage.js